import { ShieldCheck, KeyRound, Undo2 } from "lucide-react";

export function TrustBanner({ testId = "landing-trust-banner", variant = "wide" }) {
  const items = [
    {
      icon: KeyRound,
      title: "Never your main password",
      desc: "We never ask for CMS or website admin credentials.",
    },
    {
      icon: ShieldCheck,
      title: "Nothing goes live without you",
      desc: "You explicitly authorize install and approve go-live.",
    },
    {
      icon: Undo2,
      title: "Revocable & logged",
      desc: "Every action is time-stamped. Consent can be revoked any time.",
    },
  ];
  return (
    <div
      data-testid={testId}
      className={`grid gap-4 ${variant === "wide" ? "sm:grid-cols-3" : "grid-cols-1"}`}
    >
      {items.map((it) => (
        <div key={it.title} className="fs-card p-5">
          <it.icon className="w-5 h-5 text-blue-600" />
          <div className="mt-3 font-outfit font-semibold text-slate-900">
            {it.title}
          </div>
          <p className="text-sm text-slate-600 mt-1 leading-relaxed">{it.desc}</p>
        </div>
      ))}
    </div>
  );
}
